import { Routes } from '@angular/router';

import { changePasswordPageGuard } from '../core/guards/password-change-required.guard';

export const authenticationRoutes: Routes = [
  {
    path: 'ingresar',
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent),
    data: { breadcrumb: 'Iniciar sesión' },
  },
  {
    path: 'recuperar-contrasena',
    loadComponent: () =>
      import('./features/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
    data: { breadcrumb: 'Recuperar contraseña' },
  },
  {
    path: 'restablecer-contrasena',
    loadComponent: () =>
      import('./features/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
    data: { breadcrumb: 'Crear nueva contraseña' },
  },
  {
    path: 'cambiar-contrasena',
    canActivate: [changePasswordPageGuard],
    loadComponent: () =>
      import('./features/change-password/change-password.component').then((m) => m.ChangePasswordComponent),
    data: { breadcrumb: 'Cambiar contraseña' },
  },
  {
    path: 'acceso-app',
    loadComponent: () =>
      import('./features/conductor-app-access/conductor-app-access.component').then(
        (m) => m.ConductorAppAccessComponent,
      ),
    data: { breadcrumb: 'App Calypso Delivery' },
  },
];
